import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import { AggregateBy } from '@/domains/dashboard/components/GlobalfiltersRow';
import { PopperContentProps } from '@radix-ui/react-popper';
import { useDebounceValue } from '@/hooks/use-debounce';
import { FirstInteractionFilterConfig, LastInteractionFilterConfig, QueryOrdering, UsersInteractionsFilterConfig } from '@/api/generated/model';
import { getVariable, useGetFilterValues } from '@/comps/FilterPicker/utils';
import { FILTERS } from '@/models/common/filters';
import { formatDateConfigs, formatValueConfigs, isSpecialFilter } from '@/utils/filter-utils';
import { CheckedState } from '@radix-ui/react-checkbox';
import { FilterPopoverUI } from '@/comps/FilterPicker/FilterPopoverUI';
import { FilterIcon, X } from 'lucide-react';
import { cn } from '@/utils/shad';
import { Chip } from '@/comps/chip';
import { translateSafe } from '@/utils/translations';
import { PopoverClose } from '@/comps/primitives/popover';
import { WithLoadingContainer } from '@/comps/loading-spinner';
import { WhenForm } from '@/components/filters/filter-when-forms';
import { NumberOfInteractionsForm } from '@/components/filters/filter-number-of-interactions-form';
import { AvailableValue, FilterSectionProps, GenericFilter, GenericUserFilter } from '@/comps/FilterPicker/FilterPicker';
import { useFilterSelectAll } from '@/comps/FilterPicker/FilterContent';
import { FilterValueStep } from '@/comps/FilterPicker/FilterValueStep';
import { buildGenericFilter, filterToOperator, FilterOperator, isContainsFilter } from '@/comps/FilterPicker/filter-operators';
import { useGlobalFiltersContext } from '@/contexts/filters/filter-context';
export function EditFilterButton(t0) {
  const $ = _c(123);
  const {
    filters,
    setFilters,
    projectId,
    timeRange,
    additionalFilters,
    volumeKind,
    title,
    align,
    children,
    disabled,
    ignoreFilters,
    filterKind,
    selectAll,
    side,
    operator
  } = t0;
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [containsDraft, setContainsDraft] = useState("");
  const debouncedSearch = useDebounceValue(search);
  let t1;
  if ($[0] !== filterKind || $[1] !== filters) {
    let t2;
    if ($[3] !== filterKind) {
      t2 = f => f.column === filterKind;
      $[3] = filterKind;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = filters.find(t2);
    $[0] = filterKind;
    $[1] = filters;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const targetFilter = t1;
  let t2;
  if ($[5] !== targetFilter?.values) {
    t2 = () => targetFilter?.values ?? [];
    $[5] = targetFilter?.values;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  targetFilter?.values;
  let t3;
  if ($[7] !== t2) {
    t3 = t2();
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const targetFilterValues = t3;
  let t4;
  if ($[9] !== operator || $[10] !== targetFilter) {
    t4 = operator ?? (targetFilter ? filterToOperator(targetFilter) : "equals");
    $[9] = operator;
    $[10] = targetFilter;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const effectiveOperator = t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      by: getVariable(),
      direction: "desc"
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const [sortBy, setSortBy] = useState(t5);
  const {
    aggregateBy
  } = useGlobalFiltersContext();
  const shownString = _temp;
  let t6;
  if ($[13] !== filters) {
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = (acc, filter_0) => {
        if (acc[filter_0.column]) {
          acc[filter_0.column].push(...(Array.isArray(filter_0.values) ? filter_0.values : [shownString(filter_0)]));
        } else {
          acc[filter_0.column] = [...(Array.isArray(filter_0.values) ? filter_0.values : [shownString(filter_0)])];
        }
        return acc;
      };
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    t6 = filters.reduce(t7, {} as Record<string, string[]>);
    $[13] = filters;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const filtersMapByKind = t6;
  let t7;
  if ($[16] !== filterKind || $[17] !== filters) {
    let t8;
    if ($[19] !== filterKind) {
      t8 = f_0 => f_0.column !== filterKind;
      $[19] = filterKind;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    t7 = filters.filter(t8);
    $[16] = filterKind;
    $[17] = filters;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const filtersExcludingKind = t7;
  const t8 = effectiveOperator !== "contains";
  let t9;
  if ($[21] !== additionalFilters || $[22] !== aggregateBy || $[23] !== debouncedSearch || $[24] !== filterKind || $[25] !== filtersExcludingKind || $[26] !== filtersMapByKind || $[27] !== projectId || $[28] !== sortBy || $[29] !== t8 || $[30] !== timeRange || $[31] !== volumeKind) {
    t9 = {
      filters: filtersExcludingKind,
      filterKind,
      timeRange,
      projectId,
      search: debouncedSearch,
      additionalFilters,
      filtersMapByKind,
      volumeKind,
      sortBy,
      aggregateBy,
      enabled: t8
    };
    $[21] = additionalFilters;
    $[22] = aggregateBy;
    $[23] = debouncedSearch;
    $[24] = filterKind;
    $[25] = filtersExcludingKind;
    $[26] = filtersMapByKind;
    $[27] = projectId;
    $[28] = sortBy;
    $[29] = t8;
    $[30] = timeRange;
    $[31] = volumeKind;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  const {
    availableFilterValues: tempAvailableFilterValues,
    isLoading
  } = useGetFilterValues(t9);
  let t10;
  if ($[33] !== filterKind || $[34] !== ignoreFilters || $[35] !== tempAvailableFilterValues) {
    bb0: {
      if (!ignoreFilters) {
        t10 = tempAvailableFilterValues;
        break bb0;
      }
      let t11;
      if ($[37] !== filterKind) {
        t11 = f_1 => f_1.column === filterKind;
        $[37] = filterKind;
        $[38] = t11;
      } else {
        t11 = $[38];
      }
      const ignoreFilter = ignoreFilters.find(t11);
      if (!ignoreFilter) {
        t10 = tempAvailableFilterValues;
        break bb0;
      }
      t10 = tempAvailableFilterValues?.filter(av => !ignoreFilter.values.includes(av.value));
    }
    $[33] = filterKind;
    $[34] = ignoreFilters;
    $[35] = tempAvailableFilterValues;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  const availableFilterValues = t10;
  let t11;
  if ($[39] !== availableFilterValues) {
    t11 = availableFilterValues?.map(_temp2) ?? [];
    $[39] = availableFilterValues;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  const t12 = effectiveOperator === "is_not";
  let t13;
  if ($[41] !== filterKind || $[42] !== filters || $[43] !== setFilters || $[44] !== t11 || $[45] !== t12) {
    t13 = {
      filters,
      filterKind,
      availableFilterValues: t11,
      setFilters,
      isExclude: t12
    };
    $[41] = filterKind;
    $[42] = filters;
    $[43] = setFilters;
    $[44] = t11;
    $[45] = t12;
    $[46] = t13;
  } else {
    t13 = $[46];
  }
  const {
    handleOnCheckSelectAll,
    hasSelectedAll
  } = useFilterSelectAll(t13);
  let t14;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => {
      setOpen(false);
      setSearch("");
    };
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  const reset = t14;
  let t15;
  if ($[48] !== effectiveOperator || $[49] !== filterKind || $[50] !== filters || $[51] !== setFilters || $[52] !== targetFilter?.select_all) {
    t15 = values => {
      const restFilters = filters.filter(f_2 => f_2.column !== filterKind);
      if (values.length) {
        restFilters.push(buildGenericFilter({
          column: filterKind,
          operator: effectiveOperator,
          values,
          selectAll: targetFilter?.select_all
        }) as T);
      }
      setFilters(restFilters);
    };
    $[48] = effectiveOperator;
    $[49] = filterKind;
    $[50] = filters;
    $[51] = setFilters;
    $[52] = targetFilter?.select_all;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  targetFilter?.select_all;
  const handleFilterChange = t15;
  let t16;
  if ($[54] !== containsDraft || $[55] !== filterKind || $[56] !== filters || $[57] !== setFilters) {
    t16 = () => {
      const text = containsDraft.trim();
      if (!filterKind || !text) {
        return;
      }
      const restFilters_0 = filters.filter(f_3 => f_3.column !== filterKind);
      restFilters_0.push(buildGenericFilter({
        column: filterKind,
        operator: "contains",
        values: [],
        containsText: text
      }) as T);
      setFilters(restFilters_0);
      setOpen(false);
      setContainsDraft("");
    };
    $[54] = containsDraft;
    $[55] = filterKind;
    $[56] = filters;
    $[57] = setFilters;
    $[58] = t16;
  } else {
    t16 = $[58];
  }
  const handleApplyContains = t16;
  let t17;
  if ($[59] !== handleFilterChange || $[60] !== targetFilterValues) {
    t17 = function handleSelectFilterValue(value, checked) {
      const valuesSet = new Set(targetFilterValues);
      if (checked) {
        valuesSet.add(value.value);
      } else {
        valuesSet.delete(value.value);
      }
      handleFilterChange(Array.from(valuesSet));
    };
    $[59] = handleFilterChange;
    $[60] = targetFilterValues;
    $[61] = t17;
  } else {
    t17 = $[61];
  }
  const handleSelectFilterValue = t17;
  let t18;
  if ($[62] !== sortBy.direction) {
    t18 = by => {
      const newDirection = sortBy.direction === "asc" ? "desc" : "asc";
      setSortBy({
        by,
        direction: newDirection
      });
    };
    $[62] = sortBy.direction;
    $[63] = t18;
  } else {
    t18 = $[63];
  }
  const handleChangeSortByDirection = t18;
  let t19;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = v => {
      const isAlpha = v === "alphabetical";
      const dir = isAlpha ? "asc" : "desc";
      setSortBy({
        by: v,
        direction: dir
      });
    };
    $[64] = t19;
  } else {
    t19 = $[64];
  }
  const handleChangeSortBy = t19;
  let t20;
  if ($[65] !== disabled || $[66] !== targetFilter) {
    t20 = function handleOpenFilter(open_0) {
      if (disabled) {
        return;
      }
      setOpen(open_0);
      if (open_0 && targetFilter && isContainsFilter(targetFilter)) {
        setContainsDraft(targetFilter.search ?? "");
      }
      if (!open_0) {
        reset();
      }
    };
    $[65] = disabled;
    $[66] = targetFilter;
    $[67] = t20;
  } else {
    t20 = $[67];
  }
  const handleOpenFilter = t20;
  const t21 = title || "Filter";
  let t22;
  if ($[68] !== setFilters) {
    t22 = () => {
      setFilters([]);
      reset();
    };
    $[68] = setFilters;
    $[69] = t22;
  } else {
    t22 = $[69];
  }
  let t23;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = cn("flex items-center justify-between px-3 pb-2");
    $[70] = t23;
  } else {
    t23 = $[70];
  }
  let t24;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Chip size="small" className="h-7 rounded-base border bg-background px-2 py-1 font-semibold"><FilterIcon className="mr-1 inline" size={12} /><span>{translateSafe("filter", "filterBy")}</span></Chip>;
    $[71] = t24;
  } else {
    t24 = $[71];
  }
  let t25;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <header className="sticky top-0 z-40 flex min-w-67.5 flex-col gap-2 border-b bg-background pt-2 text-[12px] shadow-sm"><div className={t23}>{t24}<PopoverClose><button className="flex h-7 items-center justify-center rounded-base border p-1.5 leading-4"><X size={14} /></button></PopoverClose></div></header>;
    $[72] = t25;
  } else {
    t25 = $[72];
  }
  let t26;
  if ($[73] !== filterKind || $[74] !== filters || $[75] !== open || $[76] !== setFilters || $[77] !== timeRange) {
    t26 = open && filterKind && filterKind === FILTERS.firstInteraction && <div className="z-0 h-full! bg-background p-2"><WhenForm title="Users whose first interaction is" timeRange={timeRange} onApply={values_0 => {
        setFilters([...(filters as any), {
          column: filterKind,
          values: values_0 as any
        }]);
        setOpen(false);
      }} /></div>;
    $[73] = filterKind;
    $[74] = filters;
    $[75] = open;
    $[76] = setFilters;
    $[77] = timeRange;
    $[78] = t26;
  } else {
    t26 = $[78];
  }
  let t27;
  if ($[79] !== filterKind || $[80] !== filters || $[81] !== open || $[82] !== setFilters || $[83] !== timeRange) {
    t27 = open && filterKind && filterKind === FILTERS.lastInteraction && <div className="z-0 bg-background p-2"><WhenForm title="Users whose last interaction is" timeRange={timeRange} onApply={values_1 => {
        setFilters([...(filters as any), {
          column: filterKind,
          values: values_1 as any
        }]);
        setOpen(false);
      }} /></div>;
    $[79] = filterKind;
    $[80] = filters;
    $[81] = open;
    $[82] = setFilters;
    $[83] = timeRange;
    $[84] = t27;
  } else {
    t27 = $[84];
  }
  let t28;
  if ($[85] !== filterKind || $[86] !== filters || $[87] !== open || $[88] !== setFilters) {
    t28 = open && filterKind && filterKind === FILTERS.usersInteraction && <div className="z-0 bg-background p-2"><NumberOfInteractionsForm onApply={values_2 => {
        setFilters([...(filters as any), {
          column: filterKind,
          values: values_2 as any
        }]);
        setOpen(false);
      }} /></div>;
    $[85] = filterKind;
    $[86] = filters;
    $[87] = open;
    $[88] = setFilters;
    $[89] = t28;
  } else {
    t28 = $[89];
  }
  let t29;
  if ($[90] !== availableFilterValues || $[91] !== containsDraft || $[92] !== effectiveOperator || $[93] !== filterKind || $[94] !== handleApplyContains || $[95] !== handleChangeSortByDirection || $[96] !== handleOnCheckSelectAll || $[97] !== handleSelectFilterValue || $[98] !== hasSelectedAll || $[99] !== isLoading || $[100] !== open || $[101] !== search || $[102] !== selectAll || $[103] !== sortBy || $[104] !== targetFilterValues || $[105] !== volumeKind) {
    t29 = open && filterKind && !isSpecialFilter(filterKind) && <FilterValueStep filterKind={filterKind} operator={effectiveOperator} containsText={containsDraft} onContainsTextChange={setContainsDraft} onApplyContains={handleApplyContains} searchFilterValue={search} setSearchFilterValue={setSearch} sortBy={sortBy} onChangeSortBy={handleChangeSortBy} onChangeSortByDirection={handleChangeSortByDirection} availableFilterValues={availableFilterValues} isLoading={isLoading} targetFilterValues={targetFilterValues as string[]} hasSelectedAll={hasSelectedAll || !!selectAll} showSelectAll={true} onCheckSelectAll={handleOnCheckSelectAll} onSelectFilterValue={handleSelectFilterValue} volumeKind={volumeKind} onEmptyReset={reset} />;
    $[90] = availableFilterValues;
    $[91] = containsDraft;
    $[92] = effectiveOperator;
    $[93] = filterKind;
    $[94] = handleApplyContains;
    $[95] = handleChangeSortByDirection;
    $[96] = handleOnCheckSelectAll;
    $[97] = handleSelectFilterValue;
    $[98] = hasSelectedAll;
    $[99] = isLoading;
    $[100] = open;
    $[101] = search;
    $[102] = selectAll;
    $[103] = sortBy;
    $[104] = targetFilterValues;
    $[105] = volumeKind;
    $[106] = t29;
  } else {
    t29 = $[106];
  }
  let t30;
  if ($[107] !== isLoading || $[108] !== t26 || $[109] !== t27 || $[110] !== t28 || $[111] !== t29) {
    t30 = <div className="relative mb-1 flex h-full min-h-25 items-center"><WithLoadingContainer loading={isLoading} hideChildren={true}>{t26}{t27}{t28}{t29}</WithLoadingContainer></div>;
    $[107] = isLoading;
    $[108] = t26;
    $[109] = t27;
    $[110] = t28;
    $[111] = t29;
    $[112] = t30;
  } else {
    t30 = $[112];
  }
  let t31;
  if ($[113] !== align || $[114] !== children || $[115] !== disabled || $[116] !== handleOpenFilter || $[117] !== open || $[118] !== side || $[119] !== t21 || $[120] !== t22 || $[121] !== t30) {
    t31 = <FilterPopoverUI open={open} onOpenChange={handleOpenFilter} title={t21} disabled={disabled} triggerContent={children} appliedFiltersText="" showAppliedFilters={false} align={align} icon={FilterIcon} className="max-h-87.5 min-w-50!" side={side} nAppliedFilters={0} onFiltersClear={t22}>{t25}{t30}</FilterPopoverUI>;
    $[113] = align;
    $[114] = children;
    $[115] = disabled;
    $[116] = handleOpenFilter;
    $[117] = open;
    $[118] = side;
    $[119] = t21;
    $[120] = t22;
    $[121] = t30;
    $[122] = t31;
  } else {
    t31 = $[122];
  }
  return t31;
}
function _temp2(a) {
  return a.value;
}
function _temp(filter) {
  if (filter.column === FILTERS.firstInteraction) {
    const castFilter = filter as any as FirstInteractionFilterConfig;
    return `whose first interaction is ${formatDateConfigs(castFilter.values)}`;
  } else {
    if (filter.column == FILTERS.lastInteraction) {
      const castFilter_0 = filter as any as LastInteractionFilterConfig;
      return `whose last interaction is ${formatDateConfigs(castFilter_0.values)}`;
    } else {
      if (filter.column === FILTERS.usersInteraction) {
        const castFilter_1 = filter as any as UsersInteractionsFilterConfig;
        return `who have ${formatValueConfigs(castFilter_1.values.interactions_count)} ${castFilter_1.values.dates ? formatDateConfigs(castFilter_1.values.dates) : ""}`;
      }
    }
  }
  return "";
}